export const ADD_ERROR = 'TOASTER_NOTIFICATIONS_ADD_ERROR'
export const ADD_WARNING = 'TOASTER_NOTIFICATIONS_ADD_WARNING'
export const ADD_SUCCESS = 'TOASTER_NOTIFICATIONS_ADD_SUCCESS'
export const ADD_INFO = 'TOASTER_NOTIFICATIONS_ADD_INFO'



// WEBPACK FOOTER //
// ./src/features/Toaster/data/notifications/constants.js